import { ldb } from '@codesuma/baseline'
import type { ICollection } from './index'

const rowsFor = <T>(name: string): T[] => {
    const stored = ldb.get(name)
    return Array.isArray(stored) ? stored : []
}

// Stage 0 keeps the existing localStorage representation while exposing the
// row-level contract used by the stores above it.
export const local = <T extends { id: string }>(name: string): ICollection<T> => ({
    async load() {
        return rowsFor<T>(name)
    },

    async put(row) {
        const rows = rowsFor<T>(name)
        const found = rows.some(saved => saved.id === row.id)
        ldb.set(name, found
            ? rows.map(saved => saved.id === row.id ? row : saved)
            : [...rows, row])
    },

    async remove(id) {
        ldb.set(name, rowsFor<T>(name).filter(row => row.id !== id))
    },
})
